import { Grid, FormControlLabel } from "@mui/material";
import HighlightSwitch from "./HighlightSwitch";
import HeaderBreakdown from "./HeaderBreakdown";
import { useAppDispatch } from "src/store/store";
import { toggleMarketHighlights, useMarketsState } from "src/store/features/markets.slice";
import { trackEvent } from "src/Amplitude";
import Title from "src/components/common/Title";

const MarketHeader = () => {
  const { displayMarketHighlights } = useMarketsState();
  const dispatch = useAppDispatch();

  return (
    <Grid container alignItems="center">
      <Grid item xs={12}>
        <Title title={{ partB: "Markets" }} />
      </Grid>
      <Grid item xs={12} md={9}>
        <HeaderBreakdown />
      </Grid>
      <Grid item xs={12} md={3} sx={{ display: { sm: "block", xs: "none" } }}>
        <Grid container justifyContent="flex-end">
          <FormControlLabel
            labelPlacement="start"
            label="Highlights"
            control={
              <HighlightSwitch
                sx={{ m: 1 }}
                checked={displayMarketHighlights}
                onChange={() => dispatch(toggleMarketHighlights())}
                onClick={() =>
                  trackEvent("Select_Markets_Page", {
                    option: "Highlight_Switch",
                  })
                }
              />
            }
          />
        </Grid>
      </Grid>
    </Grid>
  );
};

export default MarketHeader;
